<template>
  <div>
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Notificações</h1>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :route="'/patients/notifications/' + patient.id"
      no-data-label="Nenhuma notificação cadastrada"
      no-result-label="Nenhuma notificação encontrada"
    >
    </data-table>
  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import Modal from '@/Shared/Modal'
import DataTable from '@/Shared/DataTable'

export default {
  inject: ['patient'],
  components: {
    Modal,
    DataTable,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user);
    return {
      user,
    }
  },
  data() {
    return {
      selectedItem: Object,
      loadTable: true,
      columns: [
        {
          uniqid: 'notifications_created_at',
          label: 'Data',
          field: 'created_at',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDateTime(row.created_at),
        },
        {
          uniqid: 'notifications_title',
          label: 'Título',
          field: 'title',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.data.title ? row.data.title : ''
        },
        {
          uniqid: 'notifications_body',
          label: 'Descrição',
          field: 'body',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.data.body ? row.data.body : ''
        },
      ],
    }
  },
  methods: {
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    }
  },
}
</script>